import { CUSTOMER_APIS } from "@/api_framework/api_config";
import { ICustomerDetailsSearchResponse } from "@/api_framework/api_modals/Users";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

AxiosCurlirize(axios, () => {});

// Lightweight name/phone lookup for the create form (does not touch profile redux).
export const useCustomerLookupAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const [customer, setCustomer] = useState<{ name: string; mobile: string; email: string } | null>(null);

  const execute = useCallback(async (userId: string) => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      return await axios
        .get(CUSTOMER_APIS?.CUSTOMER_DETAILS?.baseURL ?? "", {
          params: { user_id: userId },
          headers: { Authorization: `${accessToken}`, "Content-Type": "application/json" },
        })
        .then((res: AxiosResponse<ICustomerDetailsSearchResponse>) => {
          if (res.data.status) {
            const c = res.data.data.customer_details;
            setCustomer({ name: c.name, mobile: c.mobile, email: c.email });
            return { status: true };
          }
          setCustomer(null);
          return { status: false };
        })
        .catch((e: AxiosError) => {
          setCustomer(null);
          sendCurl(e.config["curlCommand"]);
          return { status: false };
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
      return { status: false };
    }
  }, []);

  return { execute, customer, setCustomer };
};
